import React from 'react';
import WebsiteGeneratorForm from './WebsiteGeneratorForm';

const WebsiteGenerator = () => {
  const handleFormSubmit = (data) => {
    console.log('Dane do AI:', data);
    // Tutaj będzie integracja z backendem AI.
  };

  return (
    <div className="website-generator">
      <h2>Generuj swoją stronę AI</h2>
      <WebsiteGeneratorForm onSubmit={handleFormSubmit} />
    </div>
  );
};

export default WebsiteGenerator;
